import { Mail, Notifications, Pets } from "@mui/icons-material";
import { AppBar, Avatar, Badge, Box, InputBase, Menu, MenuItem, styled, Toolbar, Typography } from "@mui/material";
import React, { useState } from "react";

const Navbar = ()=>{

    const [open, setOpen] = useState(false);

    const StyledToobar = styled(Toolbar)({
        display:"flex",
        justifyContent: "space-between"
    })

    const Search = styled("div")(({theme})=>({
        backgroundColor:"white",
        padding:"0 10px",
        borderRadius:theme.shape.borderRadius,
        width:"40%"
    }))
    const Icons = styled(Box)(({theme})=>({
        // backgroundColor:"white",
        display:"none",
        gap:"20px",
        alignItems:"center",
        [theme.breakpoints.up("sm")]:{
            display:"flex"
        }
    }))
    const UserBox = styled(Box)(({theme})=>({
        // backgroundColor:"white",
        display:"flex",
        gap:"10px",
        alignItems:"center",
        [theme.breakpoints.up("sm")]:{
            display:"none"
        }
    }))
    return (
        <AppBar position="sticky">
            <StyledToobar>
                <Typography sx={{display:{xs:"none",sm:"block"}}} variant="h6">Home</Typography>
                <Pets sx={{display:{xs:"block",sm:"none"}}}/>
                <Search>
                    <InputBase placeholder="Search..."></InputBase>
                </Search>
                <Icons>
                    <Badge badgeContent={4} color="error">
                        <Mail />
                    </Badge>
                    <Badge badgeContent={2} color="error">
                        <Notifications />
                    </Badge>
                    <Avatar sx={{width:30, height:30}} onClick={e=>setOpen(true)}/>
                </Icons>
                <UserBox onClick={e=>setOpen(true)}>
                    <Avatar sx={{width:30, height:30}}/>
                    <Typography variant="span">Kamran</Typography>
                </UserBox>
            </StyledToobar>
            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                open={open}
                onClose= {(e)=>setOpen(false)}
                anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
                }}
                transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
                }}
            >
                <MenuItem>Profile</MenuItem>
                <MenuItem>My account</MenuItem>
                <MenuItem>Logout</MenuItem>
            </Menu>
        </AppBar>
    )
}
export default Navbar;